const Location = ({ customer }) => {
  if (!customer.countryCode) {
    return null;
  }
  // what we want here is how the customer should render just the city/state
  if (customer.city && customer.stateCode && customer.countryCode) {
    return (
      <span>
        {customer.city}, {customer.stateCode}, {customer.countryCode}
      </span>
    );
  }
  if (customer.city && customer.countryCode) {
    return (
      <span>
        {customer.city}, {customer.countryCode}
      </span>
    );
  }
  if (customer.countryCode) {
    return <span>{customer.countryCode}</span>;
  }
  return null;
};

export default Location;
